module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAIAAABwJOjsAAAAu0lEQVRIx2P4P0CAYdRiMHj96sfy7d+apl5rnnZ12bZvL1/8oJPFi6ZeZ9B7Jmh1Tdj6KpAxa8J1Olm8cf41oH0idi+ACMhYOZsGFgODFBN11553S3977MLPo+d/+ua+a62+gFUZJYgB6CFMJK91Cmjrl2//gOjstV9KWiewKqMI4ZJwD701beXXqSu+ekTcpr6teCwW074YnX43Ou2OhNZ5ulpMczTyLF7u1zEgiOE/z8CgUYtHLaYZAgBzqFWn9g3K6wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/si.png
// module id = 925
// module chunks = 0